import importApi from '../../api/import/importApi';
import { ApiResponse } from '../../types/common/ApiResponse';

interface ImportExcelResponse {
  // Puedes personalizar si el backend retorna algo en `data`
  // Por ejemplo, `totalImported`, `errors`, etc.
}

const ImportExcelService = {
  /**
   * Importa datos desde un archivo Excel con el código de importación.
   */
  importExcel: async (
    file: File,
    importCode: string
  ): Promise<ApiResponse<ImportExcelResponse>> => {
    const payload = { importCode };

    const response = await importApi.postFormDataCustom(
      '/import',
      payload,
      file,
      'file'
    );

    return response.data;
  },
};

export default ImportExcelService;
